export default __webpack_public_path__ + "static/media/Athletics Track, PKL-2.6b11c1eb.jpg";